import { apiService } from '../api';
import { Supplier, CreateSupplierRequest } from '../../types/inventory';

const BASE = '/inventory/suppliers';

export const supplierService = {
  async getSuppliers(org: string, restaurantId?: string, search?: string): Promise<Supplier[]> {
    const response = await apiService.get<Supplier[]>(BASE, {
      org,
      ...(restaurantId && { restaurantId }),
      ...(search && { search }),
    });
    return response.data;
  },

  async getSupplier(id: string): Promise<Supplier> {
    const response = await apiService.get<Supplier>(`${BASE}/${id}`);
    return response.data;
  },

  async createSupplier(data: CreateSupplierRequest): Promise<Supplier> {
    const response = await apiService.post<Supplier>(BASE, data);
    return response.data;
  },

  async updateSupplier(id: string, data: Partial<CreateSupplierRequest>): Promise<Supplier> {
    const response = await apiService.put<Supplier>(`${BASE}/${id}`, data);
    return response.data;
  },

  async toggleActive(id: string): Promise<Supplier> {
    const response = await apiService.patch<Supplier>(`${BASE}/${id}/active`);
    return response.data;
  },

  async deleteSupplier(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}`);
  },
};
